import { Box, IconButton } from "@chakra-ui/react";
import { PencilIcon } from "@phosphor-icons/react/dist/ssr";

// "Dibujar perímetro" / "Dibujar perímetro adicional" — entry point to
// manual draw mode. Sits in the top-right of the map (the same slot as
// BoundaryButton / RecenterButton).
//
// Responsive: icon-only square below md (mobile/tablet portrait), icon +
// label pill at md+. The mobile collapse + the parent Flex's flexWrap
// keep all three top-right controls visible without overflowing on narrow
// screens. `additional` flips the desktop label when polygons exist —
// explicit UX hint that multi-zone is supported (P8.5).
const DibujarButton = ({ onClick, additional = false }) => {
    const label = additional ? "Dibujar perímetro adicional" : "Dibujar perímetro";
    const sharedStyles = {
        bg: "white",
        color: "gray.900",
        borderWidth: "1px",
        borderColor: "gray.300",
        borderRadius: "full",
        boxShadow: "md",
        _hover: { bg: "gray.50" },
    };
    return (
        <>
            {/* Below md: icon-only square (label lives in aria-label + title) */}
            <Box hideFrom="md">
                <IconButton
                    onClick={onClick}
                    aria-label={label}
                    title={label}
                    size="sm"
                    minW="36px"
                    w="36px"
                    px={0}
                    {...sharedStyles}
                >
                    <PencilIcon weight="bold" />
                </IconButton>
            </Box>
            {/* md+: icon + label pill */}
            <Box hideBelow="md">
                <IconButton
                    onClick={onClick}
                    aria-label={label}
                    size="sm"
                    px={4}
                    w="auto"
                    minW="auto"
                    {...sharedStyles}
                >
                    <PencilIcon weight="bold" />
                    <Box as="span" ml={2}>
                        {label}
                    </Box>
                </IconButton>
            </Box>
        </>
    );
};

export default DibujarButton;
